
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiViewDashboard,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
    mdiFaceAgent,
	mdiAccountCircle,
	mdiAccountGroup,
	mdiSchool,
	mdiBookOpenVariant,
	mdiBookshelf,
	mdiBookOpenPageVariant,
	mdiBookPlusMultiple,
	mdiHammerScrewdriver,
	mdiFormatListBulletedType,
	mdiFormatLetterMatches,
	mdiNumeric9BoxMultiple,
	mdiNotebookEdit,
	mdiAccountDetails,
	mdiTimetable,
	mdiCalendarMonth
} from '@mdi/js'
// const roles = localStorage.getItem('roles')
const menuTeacher = [
	'General',
		[
			{
				to: '/comboard-dashboard',
				icon: mdiViewDashboard,
				label: 'sidebar.dashboard'
			}
		],
		'Examples',
		[
			{
				label: 'Student',
				subLabel: 'Submenus Student',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/students',
						label: 'Students Data',
						icon: mdiAccountGroup
					}
					// {
					// 	to: '/student-doc',
					// 	label: 'Student Documents',
					// 	icon: mdiAccountGroup
					// },
					// {
					// 	to: '/parentuser',
					// 	label: 'Parents',
					// 	icon: mdiAccount
					// },
					// {
					// 	to: '/',
					// 	label: 'Users',
					// 	icon: mdiAccountMultiple
					// },
					// {
					// 	to: '/class-transfer',
					// 	label: 'Class Transfer',
					// 	icon: mdiAccountMultiplePlus
					// },
					// {
					// 	to: '/studentresignation',
					// 	label: 'Resignation',
					// 	icon: mdiAccountGroup
					// },
					// {
					// 	to: '/graduation',
					// 	label: 'Graduation',
					// 	icon: mdiAccountSchool
					// }
				]
			},
            {
				label: 'Permission Request',
				subLabel: 'Submenus Teacher',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/permissions',
						label: 'Permissions',
						icon: mdiFaceAgent
					},
         			{
						to: '/permission-reason',
						label: 'Permission Reason',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Attendance',
				subLabel: 'Submenus Attendance',
				icon: mdiAccountArrowLeft,
				menu: [
					{
						to: '/attendancelist',
						label: 'Regular Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/attendancestreaming',
						label: 'Parallel Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/reportattendancedaily',
						label: 'Daily Attendance Report',
						icon: mdiAccountAlert
					},
					{
					  to: '/assignment-special',
					  label: 'Special Assignment',
					  icon: mdiBusDoubleDecker
					}
				]
			},
			{
				label: 'Schedule',
				subLabel: 'Submenus Schedule',
				icon: mdiTimetable,
				menu: [
					// 	{
					// 	to: '/schooltime',
					// 	label: 'School Time',
					// 	icon: mdiAvTimer
					// },
					// {
					// 	to: '/studytime',
					// 	label: 'Study Time',
					// 	icon: mdiAvTimer
					// },
					{
						to: '/schedule',
						label: 'Schedule',
						icon: mdiTimetable
					},
					{
						to: '/eskulschedule',
						label: 'Extracuricular Schedule',
						icon: mdiTimetable
					},
					{
						to: '/calendar',
						label: 'Calendar',
						icon: mdiCalendarMonth
					}
				]
			},
			{
				label: 'Subject',
				subLabel: 'Submenus Subject',
				icon: mdiBookOpenVariant,
				menu: [
					{
						to: '/subject',
						label: 'Subject',
						icon: mdiBookshelf
					},
					{
						to: '/subjectgroup',
						label: 'Subject Group',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/learningmethod',
						label: 'Learning Method',
						icon: mdiBookPlusMultiple
					},
					{
						to: '/gradingaspects',
						label: 'Grading Aspects',
						icon: mdiHammerScrewdriver
					},
					{
						to: '/assignmenttype',
						label: 'Assignment Type',
						icon: mdiFormatListBulletedType
					},
					{
						to: '/grading-rule',
						label: 'Grading Rule',
						icon: mdiFormatLetterMatches
					},
					{
						to: '/finalscorerule',
						label: 'Final Score Rule',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/scoreminimum',
						label: 'Passing Grade',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/syllabus',
						label: 'Syllabus',
						icon: mdiNotebookEdit
					},
					// {
					// 	to: '/teaching-time-plan',
					// 	label: 'Teaching Timeplan',
					// 	icon: mdiTimelineClockOutline
					// },
					// {
					// 	to: '/lessonplan',
					// 	label: 'Lesson Plan',
					// 	icon: mdiPuzzle
					// },
					{
						to: '/studentparalelsubject',
						label: 'Student Parallel Subject',
						icon: mdiAccountDetails
					},
					{
						to: '/studentselectsubject',
						label: 'Student Subject Selection',
						icon: mdiAccountDetails
					}
				]
			},
			{
				label: 'Subject Assessment',
				subLabel: 'Submenus Subject Assessment',
				icon: mdiSchool,
				menu: [
					{
						to: '/lesson-assessment-regular',
						label: 'Regular',
						icon: mdiSchool
					},
					{
						to: '/lesson-assessment-parallel',
						label: 'Parallel',
						icon: mdiSchool
					},
					{
						to: '/ledger-homeroom-teacher',
						label: 'Homeroom Ledger',
						icon: mdiSchool
					},
					{
						to: '/extracuricular-score',
						label: 'Extracuricular Score',
						icon: mdiSchool
					}
				]
			}
		]
]
export default menuTeacher
